<template>
        <el-container class="dataAuthPop">
              <el-aside width="200px">
                  <el-header height="35px">部门树</el-header>
                  <Department
                      ref="treeChild"
                      v-if="isShowTree"
                      :data="treeData"
                      :defaultProps="defaultProps"
                      @nodeClick="handleTreeNode"
                  />
              </el-aside>
              <el-main>
                  <el-container>
                      <el-aside style="width: 55%">
                          <div class="tools-bar">
                              <span><el-tag type="primary">待授权部门</el-tag></span>
                              <div class="tools-search" @keyup.enter="handleSearchInDept">
                                  <el-input maxlength="100" v-model.trim="searchParams.label" placeholder="部门名称">
                                      <el-button slot="append" icon="el-icon-search" @click="handleSearchInDept"></el-button>
                                  </el-input>
                              </div>
                          </div>
                          <template v-if="multiple">
                              <el-table  :data="departmentList" @selection-change="handleSelectionChangeInDept" style="width: 100%" v-loading="inDpetloading" stripe>
                                  <el-table-column type="selection" width="55"></el-table-column>
                                  <el-table-column prop="label" label="部门名称" width="160" :show-overflow-tooltip="true"></el-table-column>
                                  <el-table-column prop="deptNameShort" label="部门简称" :show-overflow-tooltip="true" ></el-table-column>
                              </el-table>
                          </template>
                            <template v-else>
                                <el-table  :data="departmentList" highlight-current-row @current-change="handleSelectionChangeInDept" style="width: 100%" v-loading="inDpetloading" stripe>
                                    <el-table-column prop="label" label="部门名称" width="160" :show-overflow-tooltip="true"></el-table-column>
                                    <el-table-column prop="deptNameShort" label="部门简称" :show-overflow-tooltip="true" ></el-table-column>
                                </el-table>
                            </template>
                          <!-- 分页 -->
                          <el-row type="flex" justify="end">
                              <el-pagination
                                  background
                                  layout="total, prev, pager,sizes, next"
                                  :total="totalPageNumInDept"
                                  :current-page="currentPageInDept"
                                  :page-size="pageSizeInDept"
                                  :page-sizes="[5, 10, 20, 30, 50]"
                                  @size-change="queryFormDataByPageSize"
                                  @current-change="queryFormDataInDept"
                                  >
                              </el-pagination>
                          </el-row>
                      </el-aside>
                      <el-aside style="width: 45%">
                          <div class="tools-bar">
                              <span><el-tag type="success">已授权部门</el-tag></span>
                              <div class="tools-btn-group">
                                  <el-button icon="iconfont icon-other-guolv" type="primary" @click="filterResult">筛选</el-button>
                                  <el-button icon="el-icon-remove" type="danger" @click="handleRemoveSelectedUser">移除</el-button>
                              </div>
                          </div>
                          <el-table ref="multipleTable" :data="selectedOrgList" @selection-change="handleSelectionRemovedUser" tooltip-effect="dark" style="width: 100%" v-loading="unInDpetloading" stripe>
                              <el-table-column type="selection" width="55"></el-table-column>
                              <el-table-column prop="label" label="部门名称"  width="150" :show-overflow-tooltip="true"></el-table-column>
                              <el-table-column prop="operAuthIdsView"  width="220" :show-overflow-tooltip="true" label="详细权限"></el-table-column>
                               <el-table-column fixed="right" label="操作" width="70">
                                <template slot-scope="scope">
                                    <el-button  type="primary" size="mini" icon="el-icon-setting" title="设置操作权限"  circle @click="handleDetailDataOperAuth(scope.row)"></el-button>
                                </template>
                              </el-table-column>
                          </el-table>
                      </el-aside>
                  </el-container>
              </el-main>
              <el-dialog
                title="设置部门数据操作权限"
                append-to-body
                :visible.sync="isShowDetailModelAuthDialog">
                <SelectMultiple  ref="selectMultiple" :sourceOptions="sourceOptions" :selectViewFields="selectViewFields"  />
                <span slot="footer" class="dialog-footer">
                    <el-button @click="isShowDetailModelAuthDialog = false">取 消</el-button>
                    <el-button type="primary" @click="chooseModelAuth">确 定</el-button>
                </span>
              </el-dialog>
              <!-- 过滤已选择的数据 -->
              <el-dialog
                title="过滤已选择的数据"
                append-to-body
                :visible.sync="filterResultDialog">
                  <div class="result-data">
                      <div class="tools-bar">
                          <el-input placeholder="请输入内容" v-model="searchContent" class="input-with-select" style="margin-right: 20px;">
                             <el-button slot="append" icon="el-icon-search" @click="filterResultData"></el-button>
                           </el-input>
                           <el-button icon="el-icon-remove" type="danger" @click="handleRemoveFilterUser">移除</el-button>
                      </div>
                      <el-table ref="multipleTable" :data="filterSelectedOrgList" @selection-change="handleSelectionRemovedFilterDataUser" tooltip-effect="dark" style="width: 100%" v-loading="unInDpetloading" stripe>
                            <el-table-column type="selection" width="55"></el-table-column>
                            <el-table-column prop="label" label="部门名称"  width="150" :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="operAuthIdsView"  width="220" :show-overflow-tooltip="true" label="详细权限"></el-table-column>
                             <el-table-column fixed="right" label="操作" width="70">
                              <template slot-scope="scope">
                                  <el-button  type="primary" size="mini" icon="el-icon-setting" title="设置操作权限"  circle @click="handleDetailDataOperAuth(scope.row)"></el-button>
                              </template>
                            </el-table-column>
                      </el-table>
                  </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="filterResultDialog = false">取 消</el-button>
                    <el-button type="primary" @click="determineFilter">确 定</el-button>
                </span>
              </el-dialog>
          </el-container>
</template>

<script>
    import { getDepartmentTreeList, getDepartmentList } from '@/data-model';
    import mixinsNav from '@/mixins/mixins-nav';
    import Department from '@/components/Department';
    import SelectMultiple from '@/components/SelectMultiple';
    import { isEmpty, cloneDeep } from 'lodash';
    export default {
        mixins: [ mixinsNav ],
        components: {
            Department: Department,
            SelectMultiple
        },
        data () {
            return {
                isShowDetailModelAuthDialog: false,
                filterResultDialog: false,
                sourceOptions: [
                    { id: 'ALL_SELECT', label: 'ALL' },
                    { id: '0', label: '查看' },
                    // { id: '1', label: '新增' },
                    { id: '2', label: '修改' },
                    { id: '3', label: '删除' }
                ],
                selectViewFields: [],
                // isInnerShowUserOrg: false,
                treeData: [],
                searchParams: {
                    label: '',
                    id: 0,
                    name: ''
                },
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                isShowTree: false,
                empNameInDept: '',
                inDpetloading: false,
                departmentList: [], // 部门列表
                currentPageInDept: 1, // 当前页码
                pageSizeInDept: 6, // 每页条数
                totalPageNumInDept: 1, // 总页数

                unInDpetloading: false,
                empNameUnInDept: '',
                selectedOrgList: [], // 已选择的部门列表数据
                filterSelectedOrgList: [],
                filterChargeSelectedOrgList: [],
                currentPageUnInDept: 1, // 当前页码
                pageSizeUnInDept: 6, // 每页条数
                totalPageNumUnInDept: 1, // 总页数

                employeeDepartment: {
                    employeeId: '',
                    departmentId: ''
                },
                selectMap: new Map(),
                currentDepartmentId: '', // 当前点击的部门节点
                selectedOrgIds: '', // 选中的部门ID
                selectedOrgNames: '', // 选中的部门名称
                selectedOperAuthIds: '', // 选中的部门对应的操作权限
                selectedOperAuthIdsView: '',
                selectedRemovedOrgIds: '', // 选中的部门ID
                selectedRemovedFilterOrgIds: '', // 选中的部门ID
                searchContent: ''
            };
        },
        props: {
            selectedOrg: {
                type: Object,
                default: function () {
                    return {
                        selectedOrgIds: '',
                        selectedOrgNames: '',
                        selectedOperAuthIds: '',
                        selectedOperAuthIdsView: ''
                    };
                }
            },
            selectedDatas: {
                type: Array
            },
            // filterUsers: {// 需要过滤不显示的人员信息
            //     type: String,
            //     default: ''
            // },
            multiple: {
                type: Boolean,
                default: false
            }
        },
        created () {
            // this._initPage();

        },
        methods: {
            async _initPage () {
                this.selectMap = new Map();
                // if (!isEmpty(this.selectedOrg.selectedOrgIds)) {
                this.selectedOrgIds = ''; // 选中的部门ID
                this.selectedOrgNames = '';// 选中的部门名称
                this.selectedOperAuthIds = '';
                this.selectedOperAuthIdsView = '';
                if (!isEmpty(this.selectedDatas)) {
                    this.selectedDatas.forEach(row => {
                        if (isEmpty(this.selectedOrgNames)) {
                            this.selectedOrgIds = row.orgId + '';
                            this.selectedOrgNames = row.orgName;
                            this.selectedOperAuthIds = row.operAuthIds;
                            this.selectedOperAuthIdsView = row.operAuthIdsView;
                        } else {
                            this.selectedOrgIds = this.selectedOrgIds + ',' + row.orgId;
                            this.selectedOrgNames = this.selectedOrgNames + ',' + row.orgName;
                            this.selectedOperAuthIds = this.selectedOperAuthIds + ';' + row.operAuthIds;
                            this.selectedOperAuthIdsView = this.selectedOperAuthIdsView + ';' + row.operAuthIdsView;
                        }
                    });
                }
                this._getListData();
                this._getTreeData();
            },
            async _getListData () {
                await this.handleSearchInDept();
                await this.handleSearchUnInDept();
            },
            async _getTreeData () {
                let departmentTreeList = await getDepartmentTreeList();
                setTimeout(() => { // 调用子组件的方法
                    this.$refs.treeChild._refreshTreeData(departmentTreeList);
                }, 0);
                this.treeData = departmentTreeList;
                this.isShowTree = true;
            },
            handleTreeNode (data, node, tree) {
                this.searchParams.id = data.id;
                this.searchParams.name = data.label;
                this.currentPageInDept = 1;
                this.handleSearchInDept();
            },
            async handleSearchInDept () {
                this.inDpetloading = true;
                let formData = await getDepartmentList(Object.assign({}, {
                    currentPage: this.currentPageInDept,
                    pageSize: this.pageSizeInDept
                }, this.searchParams));
                if (!isEmpty(this.selectedOrgIds)) {
                    let selectedIds = this.selectedOrgIds.split(',');
                    for (let j = 0; j < selectedIds.length; j++) {
                        this.selectMap.set(selectedIds[j], selectedIds[j]);
                    }
                }
                this.departmentList = formData.data;
                this.currentPageInDept = formData.currentPage;
                this.pageSizeInDept = formData.pageSize;
                this.totalPageNumInDept = formData.totalPageNum;
                this.inDpetloading = false;
            },
            queryFormDataInDept (currentPageInDept) {
                this.currentPageInDept = currentPageInDept;
                this._getListData();
            },
            async handleSearchUnInDept () {
                this.unInDpetloading = true;
                if (!isEmpty(this.selectedOrgIds)) {
                    let ids = this.selectedOrgIds.split(',');
                    let names = this.selectedOrgNames.split(',');
                    let authIds = this.selectedOperAuthIds.split(';');
                    let authIdsView = this.selectedOperAuthIdsView.split(';');
                    let selectedData = [];
                    for (var i = 0; i < ids.length; i++) {
                        selectedData.push({id: ids[i], label: names[i], operAuthIds: authIds[i], operAuthIdsView: authIdsView[i]});
                    }
                    this.selectedOrgList = selectedData;
                } else {
                    this.selectedOrgList = [];
                }
                this.unInDpetloading = false;
            },
            queryFormDataUnInDept (currentPageUnInDept) {
                this.currentPageUnInDept = currentPageUnInDept;
                this._getListData();
            },
            async handleRemoveSelectedUser () {
                if (!isEmpty(this.selectedRemovedOrgIds)) {
                    let newIds = this.selectedRemovedOrgIds.split(',');
                    let ids = this.selectedOrgIds.split(',');
                    let names = this.selectedOrgNames.split(',');
                    let authIds = this.selectedOperAuthIds.split(';');
                    let authIdsView = this.selectedOperAuthIdsView.split(';');
                    let selectedData = [];
                    this.selectedOrgIds = '';
                    this.selectedOrgNames = '';
                    this.selectedOperAuthIds = '';
                    this.selectedOperAuthIdsView = '';
                    let removedMap = new Map();
                    for (var j = 0; j < newIds.length; j++) {
                        removedMap.set(newIds[j], newIds[j]);
                    }
                    for (var i = 0; i < ids.length; i++) {
                        if (!removedMap.has(ids[i])) {
                            selectedData.push({id: ids[i], label: names[i], operAuthIds: authIds[i], operAuthIdsView: authIdsView[i]});
                            if (isEmpty(this.selectedOrgNames)) {
                                this.selectedOrgIds = ids[i] + '';
                                this.selectedOrgNames = names[i];
                                this.selectedOperAuthIds = authIds[i];
                                this.selectedOperAuthIdsView = authIdsView[i];
                            } else {
                                this.selectedOrgIds = this.selectedOrgIds + ',' + ids[i];
                                this.selectedOrgNames = this.selectedOrgNames + ',' + names[i];
                                this.selectedOperAuthIds = this.selectedOperAuthIds + ';' + authIds[i];
                                this.selectedOperAuthIdsView = this.selectedOperAuthIdsView + ';' + authIdsView[i];
                            }
                        } else {
                            this.selectMap.delete(ids[i]);
                        }
                    }
                    this.selectedOrgList = selectedData;
                }
            },
            async handleRemoveFilterUser () {
                let arr = [];
                let brr = [];
                let selIds = this.selectedRemovedFilterOrgIds.split(',');
                for (var i = 0; i < this.filterSelectedOrgList.length; i++) {
                    var obj = this.filterSelectedOrgList[i];
                    // for (var v = 0; v < selIds.length; v++) {
                    //     if (obj.id !== selIds[v]) {
                    //         arr.push(obj);
                    //     }
                    // }
                    if (selIds.indexOf(obj.id) === -1) {
                        arr.push(obj);
                    }
                }
                for (var j = 0; j < this.filterChargeSelectedOrgList.length; j++) {
                    var obj1 = this.filterChargeSelectedOrgList[j];
                    // for (var a = 0; a < selIds.length; a++) {
                    //     if (obj1.id !== selIds[a]) {
                    //         brr.push(obj1);
                    //     }
                    // }
                    if (selIds.indexOf(obj1.id) === -1) {
                        brr.push(obj1);
                    }
                }
                this.filterSelectedOrgList = arr;
                this.filterChargeSelectedOrgList = brr;
                this.filterSelectedOrgList = cloneDeep(this.filterChargeSelectedOrgList);
                this.searchContent = '';
            },
            handleSelectionChangeInDept (rows) {
                console.log(rows);
                if (rows) {
                    if (Array.isArray(rows)) {
                        rows.forEach(row => {
                            if (row) {
                                if (!this.selectMap.has(row.id)) {
                                    if (isEmpty(this.selectedOrgNames)) {
                                        this.selectedOrgIds = row.id + '';
                                        this.selectedOrgNames = row.label;
                                        this.selectedOperAuthIds = '2,3';
                                        this.selectedOperAuthIdsView = '修改,删除';
                                    } else {
                                        this.selectedOrgIds = this.selectedOrgIds + ',' + row.id;
                                        this.selectedOrgNames = this.selectedOrgNames + ',' + row.label;
                                        this.selectedOperAuthIds = this.selectedOperAuthIds + ';' + '2,3';
                                        this.selectedOperAuthIdsView = this.selectedOperAuthIdsView + ';' + '修改,删除';
                                    }
                                    this.selectMap.set(row.id, row.id);
                                }
                            }
                        });
                    } else {
                        this.selectedOrgIds = rows.id + '';
                        this.selectedOrgNames = rows.label;
                        this.selectedOperAuthIds = '2,3';
                        this.selectedOperAuthIdsView = '修改,删除';
                    }
                    this.handleSearchUnInDept();
                }
            },
            handleSelectionRemovedUser (rows) {
                this.selectedRemovedOrgIds = '';
                if (rows) {
                    rows.forEach(row => {
                        if (row) {
                            if (isEmpty(this.selectedRemovedOrgIds)) {
                                this.selectedRemovedOrgIds = row.id;
                            } else {
                                this.selectedRemovedOrgIds = this.selectedRemovedOrgIds + ',' + row.id;
                            }
                        }
                    });
                }
            },
            handleSelectionRemovedFilterDataUser (rows) {
                this.selectedRemovedFilterOrgIds = '';
                if (rows) {
                    rows.forEach(row => {
                        if (row) {
                            if (isEmpty(this.selectedRemovedFilterOrgIds)) {
                                this.selectedRemovedFilterOrgIds = row.id;
                            } else {
                                this.selectedRemovedFilterOrgIds = this.selectedRemovedFilterOrgIds + ',' + row.id;
                            }
                        }
                    });
                }
            },
            setChoosedOrg () {
                this.selectedOrg.selectedOrgIds = this.selectedOrgIds;
                this.selectedOrg.selectedOrgNames = this.selectedOrgNames;
                this.selectedOrg.selectedOperAuthIds = this.selectedOperAuthIds;
                this.selectedOrg.selectedOperAuthIdsView = this.selectedOperAuthIdsView;
            },
            handleDetailDataOperAuth (row) { // 设置详细权限
                this.isShowDetailModelAuthDialog = true;
                this.selectRow = row;
                if (isEmpty(row.operAuthIds)) {
                    this.selectViewFields = ['2', '3'];
                } else {
                    // this.selectRow.userAuthObj = row.modelUserAuthMap[this.searchParams.formId];
                    this.selectViewFields = row.operAuthIds.split(',');
                }
                // console.log(this.selectRow);
                setTimeout(() => { // 调用子组件的方法
                    this.$refs.selectMultiple.initFields();// 每次切换model时清空显示字段
                }, 100);
            },
            async chooseModelAuth () {
                this.isShowDetailModelAuthDialog = false;
                let selectedFields = this.$refs.selectMultiple.getSelectFields();
                this.selectViewFields = selectedFields.split(',');
                let ids = this.selectedOrgIds.split(',');
                let authIds = this.selectedOperAuthIds.split(';');
                let authIdsView = this.selectedOperAuthIdsView.split(';');
                for (var i = 0; i < ids.length; i++) {
                    if (this.selectRow.id === ids[i]) {
                        authIds[i] = selectedFields;
                        authIdsView[i] = this.getAuthIdsView(selectedFields);
                    }
                }
                this.selectRow.operAuthIds = selectedFields;
                this.selectedOperAuthIds = authIds.join(';');
                this.selectedOperAuthIdsView = authIdsView.join(';');
                this.handleSearchUnInDept();
            },
            determineFilter () {
                this.selectedOrgList = cloneDeep(this.filterChargeSelectedOrgList);
                this.filterResultDialog = false;
            },
            getAuthIdsView (selectedFields) {
                let authIdsView = '';
                authIdsView = selectedFields.replace('0', '查看');
                authIdsView = authIdsView.replace('1', '新增');
                authIdsView = authIdsView.replace('2', '修改');
                authIdsView = authIdsView.replace('3', '删除');
                return authIdsView;
            },
            queryFormDataByPageSize (pageSize) {
                this.pageSizeInDept = pageSize;
                this._getListData();
            },
            filterResult () {
                this.filterResultDialog = true;
                this.filterSelectedOrgList = cloneDeep(this.selectedOrgList);
                this.filterChargeSelectedOrgList = cloneDeep(this.selectedOrgList);
            },
            filterResultData () {
                if (this.searchContent === '') {
                    this.filterSelectedOrgList = cloneDeep(this.filterChargeSelectedOrgList);
                } else {
                    let arr = [];
                    for (var i = 0; i < this.filterSelectedOrgList.length; i++) {
                        var obj = this.filterSelectedOrgList[i];
                        if (obj.label.indexOf(this.searchContent) !== -1) {
                            arr.push(obj);
                        }
                    }
                    this.filterSelectedOrgList = arr;
                }
            }
        }
    };
</script>

<style lang="less">
    .dataAuthPop {
        height: 365px;
        .el-header {
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .el-main {
            padding: 0;
        }

        .el-aside {
            border-right: 1px solid #dcdfe6;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/DataAuthPop/DataAuthPop.vue